<!-- ✅ FLOATING LABEL STYLE -->
<div *ngIf="floating && !icon && !prefixText" class="form-floating">
  <input
    [type]="type"
    class="form-control"
    [class.is-valid]="valid"
    [class.is-invalid]="invalid"
    [id]="label | lowercase"
    [placeholder]="placeholder || label"
    [ngModel]="value"
    (ngModelChange)="valueChange.emit($event)"
    [disabled]="disabled"
  />
  <label [for]="label | lowercase">{{ label }}</label>
</div>

<div
  *ngIf="!floating && (icon || prefixText)"
  class="input-group"
  [ngClass]="{
    'input-group-sm': size === 'sm',
    'input-group-lg': size === 'lg'
  }"
>
  <span class="input-group-text">
    <i *ngIf="icon" [class]="icon"></i>
    <span *ngIf="!icon && prefixText">{{ prefixText }}</span>
  </span>
  <input
    [type]="type"
    class="form-control"
    [placeholder]="placeholder || label"
    [class.is-valid]="valid"
    [class.is-invalid]="invalid"
    [ngModel]="value"
    (ngModelChange)="valueChange.emit($event)"
    [disabled]="disabled"
  />
</div>

<div *ngIf="!floating && !icon && !prefixText">
  <label class="form-label fw-semibold">{{ label }}</label>
  <input
    [type]="type"
    class="form-control"
    [placeholder]="placeholder"
    [ngModel]="value"
    (ngModelChange)="valueChange.emit($event)"
    [disabled]="disabled"
  />
</div>
